function Footer() {
  return <footer className="my-4 text-center small">Copyright © TLW Solutions {new Date().getFullYear()}.</footer>;
}

export default Footer;
